goog.provide("shadow.js.shim.module$$carbon$icons_react$es$security$24");
goog.provide("module$shadow_js_shim_module$$carbon$icons_react$es$security$24");
shadow.js.shim.module$$carbon$icons_react$es$security$24 = shadow.js.nativeProvides["@carbon/icons-react/es/security/24"] = shadow$bridge("@carbon/icons-react/es/security/24");
module$shadow_js_shim_module$$carbon$icons_react$es$security$24.default = shadow.js.shim.module$$carbon$icons_react$es$security$24;
